module.exports = __webpack_public_path__ + "img/ltkfindsunder100-4x.cf18fac.jpg";